import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import i18n from "../i18n";

const LanguageContext = createContext({ language: "en", setLanguage: () => {} });

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(() => i18n.resolvedLanguage || i18n.language || "en");

  useEffect(() => {
    const handleChange = (lng) => setLanguageState(lng || "en");
    i18n.on("languageChanged", handleChange);
    setLanguageState(i18n.resolvedLanguage || i18n.language || "en");
    return () => {
      i18n.off("languageChanged", handleChange);
    };
  }, []);

  const setLanguage = useCallback((lng) => {
    if (!lng) return;
    i18n.changeLanguage(lng);
  }, []);

  return <LanguageContext.Provider value={{ language, setLanguage }}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};

export default LanguageContext;
